import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  button: {
    color: theme.palette.secondary.dark,
    fill: theme.palette.secondary.dark
  }
}))
